import { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import TechnicianForm from "@/components/TechnicianForm";
import PartnerForm from "@/components/PartnerForm";

export default function CareersPage() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    }
  }, []);

  return (
    <>
      <Seo
        title="Careers & Partnerships | DuroTech28 — DFW"
        description="Join DuroTech28 as an installation technician or partner with us in Dallas–Fort Worth. Apply online or submit a partnership inquiry."
        canonical="https://durotech28.me/careers-partners"
      />
      <Nav />
      <main data-testid="careers-page">
        <header className="max-w-4xl mx-auto px-6 pt-16 pb-12 text-center">
          <span className="text-xs uppercase tracking-widest text-[#d4af37] font-mono">Work With DuroTech28</span>
          <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight text-white mt-3 leading-[1.05]">
            Building Strong Partnerships.<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] via-[#fff4cc] to-[#c0c0c0]">Creating Opportunities.</span><br />
            Delivering Excellence.
          </h1>
          <p className="text-sm text-zinc-400 leading-relaxed max-w-2xl mx-auto mt-6">
            DuroTech28 is building a network of skilled technicians, independent subcontractors, and trusted
            business partners throughout the Dallas–Fort Worth Metroplex and surrounding areas. Whether you're
            a technician seeking project opportunities or a company looking for a reliable technology
            installation partner, we'd love to connect.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mt-8">
            <a href="#technician" data-testid="careers-jump-tech"
              className="px-6 py-3 rounded bg-gradient-to-r from-[#d4af37] to-[#e6ca65] text-black font-bold uppercase tracking-wider text-xs hover:opacity-95 transition-opacity">
              Technician Application
            </a>
            <a href="#partner" data-testid="careers-jump-partner"
              className="px-6 py-3 rounded border border-[#d4af37]/40 text-[#d4af37] font-bold uppercase tracking-wider text-xs hover:bg-[#d4af37] hover:text-black transition-colors">
              Partnership Inquiry
            </a>
          </div>
        </header>

        <section id="technician" className="max-w-4xl mx-auto px-6 pb-16 scroll-mt-24" data-testid="technician-section">
          <div className="rounded-2xl p-6 sm:p-10 bg-[#121216] gold-border">
            <h2 className="font-display text-2xl sm:text-3xl uppercase text-white mb-2">Join Our Technician Network</h2>
            <p className="text-xs text-zinc-500 font-mono mb-8">Fields marked * are required. Submission does not guarantee employment or project work.</p>
            <TechnicianForm />
          </div>
        </section>

        <section id="partner" className="max-w-4xl mx-auto px-6 pb-20 scroll-mt-24" data-testid="partner-section">
          <div className="rounded-2xl p-6 sm:p-10 bg-gradient-to-b from-[#14141a] to-[#0d0d10] border border-[#d4af37]/30">
            <span className="text-[10px] font-mono uppercase tracking-widest text-[#d4af37]">Partner With DuroTech28</span>
            <h2 className="font-display text-2xl sm:text-3xl uppercase text-white mt-2 mb-3">
              Your Projects. Our Expertise. One Reliable Partnership.
            </h2>
            <p className="text-xs text-zinc-400 leading-relaxed mb-8">
              DuroTech28 welcomes opportunities to partner with prime contractors, national installation
              providers, general contractors, managed service providers, telecommunications companies, and
              enterprise technology organizations. We provide professional technology installation and
              infrastructure services for residential, commercial, and data center environments — from
              project-based installation support and field technicians to ongoing subcontractor relationships.
            </p>
            <PartnerForm />
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
